/* eslint-disable react-hooks/exhaustive-deps */
import './MenuBar.scss';

import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {deleteCookie, getCookie} from '../../lib/cookieHelper';
import {GetRequest} from '../../lib/AxiosHelper';
import {API_AUTHACTION_ME, API_EMPLOYEE_ME} from '../../const/Api';
import {logout, setAvailableMenu, setCurrentPeriodId, setUserInfo} from '../../stores/actions/appStateAction';
import axios from 'axios';
import {ALERT_VARIANT, COOKIE_AUTHTOKEN, EMenuId, EPathname} from '../../const/dataEnum';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {FmlxCommandBarContainer, FmlxNavigationSidebar} from 'fmlx-common-ui';
import {useHistory, useLocation} from 'react-router-dom';
import {getMenuIdByPathname, getPageTitleByMenuId, getPathByMenuId} from '../../stores/business/appBusiness';
import {MenuData} from './MenuData';
import PeriodDropdown from '../../components/CommonDropdown/PeriodDropdown';
import {reviewPeriodBusiness} from '../../stores/business/reviewPeriodBusiness';
import NotificationBadge from '../BadgeWithNotification/BadgeNotification';
import {resetSelectedPeriod} from '../../stores/actions/periodAction';
import {DISABLE_PAGE} from '../../const/options';

function MenuBar() {
  const dispatch = useDispatch();
  const {authtoken, user, menu, swVersion, isSavingReview, currentPeriod} = useSelector((state) => ({
    authtoken: state.appState.authtoken,
    user: state.appState.user,
    menu: state.appState.menu,
    swVersion: state.appState.swVersion,
    isSavingReview: state.appState.isSavingReview,
    currentPeriod: state.appState.currentPeriod,
  }));
  const [menus, setMenus] = useState([]);
  const [selectedSidebarItem, setSelectedSidebarItem] = useState({
    current: null,
    previous: null,
  });

  const history = useHistory();
  const location = useLocation();
  const currentPath = useRef(null);

  const isDropdownDisabled = DISABLE_PAGE.includes(location.pathname);

  /** select sidebar item based on location pathname */
  if (
    currentPath.current !== location.pathname ||
    (selectedSidebarItem.previous === null && selectedSidebarItem.current === null)
  ) {
    const menuId = getMenuIdByPathname(location.pathname);
    if (menuId) {
      setSelectedSidebarItem((prevSelected) => ({...prevSelected, previous: menuId}));
    }
    currentPath.current = location.pathname;
  }

  useEffect(() => {
    GetMyMenu();
  }, [menu]);

  useEffect(() => {
    if (user === undefined && authtoken !== undefined) {
      GetRequest(dispatch, API_EMPLOYEE_ME).then((myData) => {
        if (myData.data.responseCode === 0) {
          dispatch(setUserInfo(myData.data.data[0]));
          GetRequest(dispatch, API_AUTHACTION_ME).then((myActions) => {
            if (myActions.data.responseCode === 0) {
              dispatch(setAvailableMenu(myActions.data.data));
            } else if (myActions.data.responseCode < -1) {
              dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: myActions.data.message}));
              deleteCookie(COOKIE_AUTHTOKEN);
              dispatch(logout());
              localStorage.clear();
            }
          });
        } else if (myData.data.responseCode < -1) {
          dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: myData.data.message}));
          deleteCookie(COOKIE_AUTHTOKEN);
          dispatch(logout());
          localStorage.clear();
        }
      });
    }
  }, [authtoken]);

  async function Logout() {
    await deleteCookie(COOKIE_AUTHTOKEN);
    await dispatch(logout());
    await localStorage.clear();
    // dispatch(updateHeaders());
    axios.defaults.headers.common['Authorization'] = ``;
  }

  const GetMyMenu = () => {
    if (menu.length > 0) {
      let menuTemp = [];

      /** generate sub menu  */
      menu.forEach((m) => {
        const filteredMenu = MenuData.find((md) => md.id === m.id);
        if (filteredMenu) {
          menuTemp.push({
            ...filteredMenu,
          });
        }
      });

      /** generata parent menu */
      const doesManageReviewHaveChildren = menuTemp.filter((mn) => mn.parentId === EMenuId.MANAGE_REVIEW).length > 0;
      const doesMasterDataHaveChildren = menuTemp.filter((mn) => mn.parentId === EMenuId.MASTER_DATA).length > 0;

      if (doesManageReviewHaveChildren) {
        const manageReviewMenu = MenuData.find((mn) => mn.id === EMenuId.MANAGE_REVIEW);
        if (manageReviewMenu) {
          menuTemp.push({
            ...manageReviewMenu,
          });
        }
      }

      if (doesMasterDataHaveChildren) {
        const masterDataMenu = MenuData.find((mn) => mn.id === EMenuId.MASTER_DATA);
        if (masterDataMenu) {
          menuTemp.push({
            ...masterDataMenu,
          });
        }
      }

      const logoutMenu = MenuData.find((mn) => mn.id === EMenuId.LOGOUT);
      if (logoutMenu) {
        menuTemp.push({
          ...logoutMenu,
        });
      }

      menuTemp = menuTemp.sort((a, b) => a.orderNumber - b.orderNumber);
      setMenus(menuTemp);
    }
  };

  const onSidebarItemClick = ({id, hasChild}) => {
    if (id === EMenuId.LOGOUT) {
      Logout();

      return;
    }

    setSelectedSidebarItem((prevSelected) => {
      if (prevSelected.previous !== id) {
        const path = getPathByMenuId(id);
        if (path) {
          history.push(path);
        }
        if (hasChild) {
          return {...prevSelected, current: id, previous: id};
        }
        if (!isSavingReview && id !== EMenuId.MESSAGE_INBOX) {
          return {...prevSelected, current: null, previous: id};
        } else {
          return {...prevSelected, current: null};
        }
      }
      return {
        ...prevSelected,
        current: prevSelected.current === id ? null : id,
      };
    });
  };

  const onSidebarBlurHandler = () => {
    setSelectedSidebarItem((prevState) => ({...prevState, current: null}));
  };

  const fetchReviewPeriods = async () => {
    const reviewPeriods = await dispatch(reviewPeriodBusiness.getAll());
    if (reviewPeriods) {
      const activeReviewPeriod = reviewPeriods.find((rp) => rp.isActive);
      dispatch(
        setCurrentPeriodId({
          id: activeReviewPeriod?.id,
          periode: activeReviewPeriod?.period,
          isActive: activeReviewPeriod?.isActive,
        })
      );
    }
  };

  useEffect(() => {
    if (!location.state?.periodID) {
      if (!DISABLE_PAGE.includes(location.pathname)) {
        dispatch(resetSelectedPeriod());
      }
      fetchReviewPeriods();
    }
  }, [location.pathname]);

  const handleChangePeriod = async (value) => {
    if (value === null) {
      await fetchReviewPeriods();
    } else {
      dispatch(
        setCurrentPeriodId({
          id: value?.id,
          periode: value?.period,
          isActive: value?.isActive,
        })
      );
    }
  };

  const handleClickedMessage = () => {
    history.push(EPathname.MESSAGE_INBOX_USER);
  };

  return (
    <>
      <div className="command-bar-container-menu">
        <FmlxCommandBarContainer>
          <FmlxCommandBarContainer.Title size="lg" weight="regular" fontStyle="branding">
            {getPageTitleByMenuId(location.pathname)}
          </FmlxCommandBarContainer.Title>
          <FmlxCommandBarContainer.ContainerItem>
            <div className="command-bar-container--left-content">
              {!isDropdownDisabled && (
                <>
                  <div className="command-bar-container--left-content-label">Select period :</div>
                  <div className="command-bar-container--left-content-dropdown">
                    <PeriodDropdown
                      callbackChangePeriod={(value) => {
                        handleChangePeriod(value);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </FmlxCommandBarContainer.ContainerItem>
          <FmlxCommandBarContainer.ContainerItem>
            <div className="command-bar-container--right-content">
              <div className="command-bar-container--right-content--col1">
                <span className="command-bar-container--right-content--user">{user ? user.fullName : '-'}</span>
                <span className="command-bar-container--right-content--role">
                  {user ? `${user.practice.practiceName} - ${user.authRole.role} - v${swVersion}` : '-'}
                </span>
              </div>
            </div>
            <div style={{paddingLeft: '20px'}}>
              <NotificationBadge clickHandler={handleClickedMessage} />
            </div>
          </FmlxCommandBarContainer.ContainerItem>
        </FmlxCommandBarContainer>
      </div>
      <div className="side-menu">
        <FmlxNavigationSidebar
          selectedItem={selectedSidebarItem}
          items={menus
            .filter((menu) => menu.id !== EMenuId.MESSAGE_INBOX_USER)
            .map((menu) => ({
              ...menu,
              onClick: onSidebarItemClick,
            }))}
          bottomPositionItemId={EMenuId.LOGOUT}
          onBlur={onSidebarBlurHandler}
        />
      </div>
    </>
  );
}

export default MenuBar;
